// An added error type to track individual failures in a batch request to OpenAI
export const FinishReasonError = 'error';
